module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("签约")])]), _vm._v(" "), _c('nav', {
    staticClass: "bar-footer btn-group"
  }, [_c('button', {
    staticClass: "btn btn-action",
    attrs: {
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.agree($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('iframe', {
    ref: "frame",
    staticClass: "frame",
    attrs: {
      "src": _vm.protocolUrl,
      "frameborder": "0"
    }
  })], 1), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('toast', {
    attrs: {
      "show": _vm.toastShow,
      "text": _vm.toastText
    },
    on: {
      "hidden": function($event) {
        _vm.toastShow = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec5b6674!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/sign.vue
// module id = 379
// module chunks = 1